const formatError = (error)=>{
    if (!error) {
        return '';
    }
    // TODO: remove this and parse the rules so we can use bloomreach labels to format them
    if ('policy' in error && error.policy === 'string') {
        return error.policy.split(/\*\s?/);
    }
    if ('description' in error) {
        if (typeof error.description === 'string') {
            return error.description;
        }
        if (typeof error.description === 'object' && error.description.rules) {
            return error.description.rules.map((r)=>r.message
            );
        }
    }
    if ('message' in error) {
        return error.message;
    }
    return '';
};

export { formatError };
//# sourceMappingURL=format-error.js.map
